import { lazy } from 'react'
import type { RouteObject } from 'react-router'
const PagePartenaires = lazy(() =>
  import('./PagePartenaires').then((m) => ({ default: m.PagePartenaires })),
)
const FichePartenaire = lazy(() =>
  import('./PagePartenaires').then((m) => ({ default: m.FichePartenaire })),
)
const PageOperateurPartenaire = lazy(() =>
  import('./PageOperateurPartenaire').then((m) => ({ default: m.PageOperateurPartenaire })),
)
export const routesPartenairesAdmin: RouteObject[] = [
  { index: true, element: <PagePartenaires /> },
  { path: ':id', element: <FichePartenaire /> },
]
export const routesPartenaireOperateur: RouteObject[] = [
  { index: true, element: <PageOperateurPartenaire /> },
]
